"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const vuex_class_1 = require("vuex-class");
const vue_property_decorator_1 = require("vue-property-decorator");
let Consuta = class Consuta extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mensajeDefault = `Hola,
vi esta propiedad y quiero que me contacten.
Gracias.`;
        this.show = this.value;
        this.loading = false;
        this.email = "";
        this.nombre = "";
        this.apellido = "";
        this.telefono = "";
        this.mensaje = this.mensajeDefault;
    }
    onShowChanged() {
        if (this.value !== this.show) {
            this.$emit("input", this.show);
        }
    }
    onValueChanged() {
        if (this.value !== this.show) {
            this.show = this.value;
        }
    }
    enviar() {
        this.loading = true;
        const params = {
            email: this.email,
            nombre: this.nombre,
            mensaje: this.mensaje,
            apellido: this.apellido,
            telefono: this.telefono,
            inmueble_id: this.inmuebleId,
            recaptcha: this.recaptchaToken,
        };
        axios_1.default
            .post("/api/inmueble/consulta", params)
            .then((response) => {
            this.$bvToast.toast(response.data.mensaje, {
                solid: true,
                title: "Consulta de Inmueble",
                variant: "success",
                toaster: "b-toaster-top-full",
            });
        })
            .catch((error) => {
            this.$bvToast.toast(error, {
                solid: true,
                title: `Error`,
                variant: `danger`,
            });
        })
            .finally(() => {
            this.show = false;
            this.loading = false;
            this.email = "";
            this.nombre = "";
            this.apellido = "";
            this.telefono = "";
            this.mensaje = this.mensajeDefault;
        });
    }
    get btnDisabled() {
        return (this.loading ||
            !this.email ||
            !this.nombre ||
            !this.telefono ||
            !this.mensaje);
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: true }),
    __metadata("design:type", Boolean)
], Consuta.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], Consuta.prototype, "inmuebleId", void 0);
__decorate([
    vuex_class_1.Getter("getRecaptchaToken"),
    __metadata("design:type", String)
], Consuta.prototype, "recaptchaToken", void 0);
__decorate([
    vue_property_decorator_1.Watch("show"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Consuta.prototype, "onShowChanged", null);
__decorate([
    vue_property_decorator_1.Watch("value"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Consuta.prototype, "onValueChanged", null);
Consuta = __decorate([
    vue_property_decorator_1.Component({ components: {} })
], Consuta);
exports.default = Consuta;
